import React from 'react';
import { Box, Button, Flex, HStack, Text } from '@chakra-ui/react';
import { DownloadIcon } from '@chakra-ui/icons';
import templateFile from "../../../assets/Template.xlsx";

const TEMPLATE_DOWNLOAD_URL = templateFile;

const TemplateDownloadBanner = () => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      gap={3}
      backgroundColor="#F0FDF4"
      border="1.5px solid"
      borderColor="#86EFAC"
      borderRadius="10px"
      p={3}
      mb={4}
    >
      <HStack spacing={3} flexShrink={1} minWidth={0}>
        {/* Excel-style icon */}
        <Box
          as="svg"
          width="28px"
          height="28px"
          viewBox="0 0 28 28"
          fill="none"
          flexShrink={0}
        >
          <rect width="28" height="28" rx="5" fill="#1D6F42" />
          <text x="5" y="20" fontSize="13" fontWeight="bold" fill="white" fontFamily="monospace">
            XLS
          </text>
        </Box>

        <Box>
          <Text fontWeight="600" fontSize="14px" color="#14532D" mb={0}>
            Uploading Excel?
          </Text>
          <Text fontSize="12px" color="gray.600" mt="2px">
            Use our template to ensure your data is formatted correctly.{' '}
            <Box as="span" color="gray.400" fontStyle="italic">
              PDF, DOC, DOCX, HL7 upload as-is.
            </Box>
          </Text>
        </Box>
      </HStack>

      <Button
        as="a"
        href={TEMPLATE_DOWNLOAD_URL}
        download="Template.xlsx"
        leftIcon={<DownloadIcon />}
        size="sm"
        backgroundColor="#1D6F42"
        color="white"
        borderRadius={8}
        fontWeight="600"
        flexShrink={0}
        _hover={{ backgroundColor: "#155734", textDecoration: "none" }}
      >
        Download Template
      </Button>
    </Flex>
  );
};

export default TemplateDownloadBanner;